import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useThemeMode } from "../../context/contextTheme";
import { useDesign } from "../../context/contextDesign";

const Breadcrumb = () => {
  const { theme } = useThemeMode();
  const { activeNav, setActiveNav } = useDesign();
  const location = useLocation();
  const paths = location.pathname.split("/").filter(Boolean);
  const navigate = useNavigate();

  return (
    <nav
      aria-label="breadcrumb"
      style={{
        // backgroundColor: theme.background2,
        borderRadius: "0.375rem",
        "--bs-breadcrumb-divider": `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='${encodeURIComponent(theme.textMuted)}'/%3E%3C/svg%3E")`,
      }}
    >
      <ol className="breadcrumb mb-3">
        <li className="breadcrumb-item">
          <Link to="/" style={{ color: theme.textMuted }}>
            Home
          </Link>
        </li>
        {paths.map((segment, index) => {
          const fullPath = "/" + paths.slice(0, index + 1).join("/");
          const isLast = index === paths.length - 1;

          return (
            <li
              className={`breadcrumb-item${isLast ? " active" : ""}`}
              key={fullPath}
              aria-current={isLast ? "page" : undefined}
              style={{ color: isLast ? theme.textColor : theme.textMuted }}
            >
              {isLast ? (
                decodeURIComponent(segment)
              ) : (
                <Link
                  to={fullPath}
                  style={{ color: theme.textMuted }}
                  onClick={() => {
                    navigate(fullPath);
                    setActiveNav(index);
                  }}
                >
                  {decodeURIComponent(segment)}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
